<p-toast></p-toast>
<div class="loading-overlay flex flex-column" *ngIf="loading">
    <span class="loader"></span>
    <span class="text-white text-xl">Enviando Mensajes...</span>
</div>

<div class="grid">
    <div class="col-12">
        <div class="card p-4">
            <!-- TÍTULO -->
            <div class="flex align-items-center justify-content-between mb-4">
                <div>
                    <h2 class="m-0 text-900">📱 Enviar Mensaje</h2>
                    <span class="text-500">Envía mensajes SMS o WhatsApp a tus contactos</span>
                </div>
            </div>

            <form *ngIf="formGroup" [formGroup]="formGroup">
                <!-- EMPRESA (solo superadmin) -->
                <div class="grid mb-4 p-3 surface-50 border-round" *ngIf="currentUser.superusuario">
                    <div class="col-12 md:col-2">
                        <label class="block text-500 text-sm mb-1">Empresa ID</label>
                        <div class="p-inputgroup">
                            <input pInputText formControlName="id_empresa" (change)="onEmpresa()" placeholder="ID"/>
                            <button pButton icon="pi pi-search" (click)="onListaEmpresa()"></button>
                        </div>
                    </div>
                    <div class="col-12 md:col-10">
                        <label class="block text-500 text-sm mb-1">Nombre de la Empresa</label>
                        <input pInputText formControlName="nombre_empresa" readonly class="w-full bg-white"/>
                    </div>
                </div>

                <!-- 4 cards: grid anidado -->
                <div class="mb-4">
                    <!-- Fila principal: 2 columnas -->
                    <div class="grid mb-3">
                        <!-- Columna 1: ¿A quién enviar? -->
                        <div class="col-6 p-3 surface-50 border-round">
                            <!-- Título sección -->
                            <div class="mb-1 text-center">
                                <span class="text-900 font-semibold text-sm">1. ¿A quién enviar?</span>
                            </div>
                            <!-- Grid interno: Contactos + Excel -->
                            <div class="grid">
                                <div class="col-6">
                                    <div class="border-2 border-round p-3 cursor-pointer transition-colors transition-duration-200 h-full"
                                        [class.border-blue-500]="formGroup.get('origen').value === 'contactos'"
                                        [class.surface-50]="formGroup.get('origen').value === 'contactos'"
                                        [class.border-300]="formGroup.get('origen').value !== 'contactos'"
                                        (click)="onOrigenSeleccion('contactos')">
                                        <div class="flex align-items-center">
                                            <div class="flex align-items-center justify-content-center surface-100 border-circle w-2rem h-2rem mr-2">
                                                <i class="pi pi-users text-lg text-600"></i>
                                            </div>
                                            <div>
                                                <span class="font-bold">Contactos</span>
                                                <p class="text-500 m-0 text-xs">De mi BD</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="border-2 border-round p-3 cursor-pointer transition-colors transition-duration-200 h-full"
                                        [class.border-blue-500]="formGroup.get('origen').value === 'excel'"
                                        [class.surface-50]="formGroup.get('origen').value === 'excel'"
                                        [class.border-300]="formGroup.get('origen').value !== 'excel'"
                                        (click)="onOrigenSeleccion('excel')">
                                        <div class="flex align-items-center">
                                            <div class="flex align-items-center justify-content-center surface-100 border-circle w-2rem h-2rem mr-2">
                                                <i class="pi pi-file-excel text-lg text-green-600"></i>
                                            </div>
                                            <div>
                                                <span class="font-bold">Excel</span>
                                                <p class="text-500 m-0 text-xs">Subir archivo</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Columna 2: Tipo de mensaje -->
                        <div class="col-6 p-3 surface-50 border-round">
                            <!-- Título sección -->
                            <div class="mb-1 text-center">
                                <span class="text-900 font-semibold text-sm">2. Tipo de mensaje</span>
                            </div>
                            <!-- Grid interno: SMS + WhatsApp -->
                            <div class="grid">
                                <div class="col-6">
                                    <div class="border-2 border-round p-3 cursor-pointer transition-colors transition-duration-200 h-full"
                                        [class.border-blue-500]="formGroup.get('tipo').value === TIPO_SMS"
                                        [class.surface-50]="formGroup.get('tipo').value === TIPO_SMS"
                                        [class.border-300]="formGroup.get('tipo').value !== TIPO_SMS"
                                        (click)="onTipoSeleccion(TIPO_SMS)">
                                        <div class="flex align-items-center">
                                            <div class="flex align-items-center justify-content-center surface-100 border-circle w-2rem h-2rem mr-2">
                                                <i class="pi pi-comment text-lg text-600"></i>
                                            </div>
                                            <div>
                                                <span class="font-bold">SMS</span>
                                                <p class="text-500 m-0 text-xs">160 caracteres</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="border-2 border-round p-3 cursor-pointer transition-colors transition-duration-200 h-full"
                                        [class.border-blue-500]="formGroup.get('tipo').value === TIPO_WHATSAPP"
                                        [class.surface-50]="formGroup.get('tipo').value === TIPO_WHATSAPP"
                                        [class.border-300]="formGroup.get('tipo').value !== TIPO_WHATSAPP"
                                        (click)="onTipoSeleccion(TIPO_WHATSAPP)">
                                        <div class="flex align-items-center">
                                            <div class="flex align-items-center justify-content-center surface-100 border-circle w-2rem h-2rem mr-2">
                                                <i class="pi pi-whatsapp text-lg text-green-500"></i>
                                            </div>
                                            <div>
                                                <span class="font-bold">WhatsApp</span>
                                                <p class="text-500 m-0 text-xs">Plantillas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- DESTINATARIOS - CONTACTOS (si eligió contactos) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="origenSeleccionado === 'contactos'">
                    <div class="flex align-items-center mb-3">
                        <span class="text-900 font-bold">Seleccionar contactos de la lista</span>
                    </div>
                    
                    <!-- Filtro por tipo de tarjeta (solo cooperativas) -->
                    <div class="flex gap-3 mb-3" *ngIf="esEmpresaSeleccionadaCooperativa()">
                        <div class="flex-auto">
                            <label class="block text-500 text-sm mb-1">Tipo de tarjeta</label>
                            <p-dropdown [options]="contactosMedalla" formControlName="contactos_medalla" 
                                optionLabel="nombre" optionValue="valor" styleClass="w-full"
                                (onChange)="cargarContactos()">
                            </p-dropdown>
                        </div>
                    </div>
                    
                    <!-- Selector de números -->
                    <div>
                        <label class="block text-500 text-sm mb-1">
                            <i class="pi pi-phone mr-1"></i>
                            Destinatarios ({{ numerosSeleccionados?.length || 0 }} seleccionados)
                        </label>
                        <p-multiSelect 
                            [options]="numeros" 
                            display="chip" 
                            optionLabel="label" 
                            optionValue="celular"
                            formControlName="numerosSeleccionados" 
                            (onFilter)="onFilter($event)"
                            placeholder="Buscar y seleccionar números..."
                            [filter]="true"
                            [showClear]="true"
                            styleClass="w-full">
                        </p-multiSelect>
                    </div>
                </div>

                <!-- DESTINATARIOS - EXCEL (si eligió excel) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="origenSeleccionado === 'excel'">
                    <div class="flex align-items-center mb-3">
                        <i class="pi pi-file-excel text-2xl text-green-500 mr-2"></i>
                        <span class="text-900 font-bold">Subir archivo con destinatarios</span>
                    </div>
                    
                    <!-- Instructivo de columnas requeridas -->
                    <div class="mb-3 p-2 surface-100 border-round">
                        <div class="flex align-items-center text-sm text-600">
                            <i class="pi pi-info-circle mr-2"></i>
                            <span>El archivo debe tener las siguientes columnas en la primera fila:</span>
                        </div>
                        <div class="mt-2 flex gap-3 flex-wrap">
                            <span class="p-tag p-tag-success">telefono / celular (obligatorio)</span>
                            <span class="p-tag">nombre (opcional)</span>
                            <span class="p-tag">correo (opcional)</span>
                        </div>
                    </div>
                    
                    <p-fileUpload 
                        mode="advanced"
                        chooseLabel="Seleccionar archivo Excel o CSV"
                        uploadLabel="Subir"
                        cancelLabel="Cancelar"
                        [auto]="false"
                        accept=".xlsx,.xls,.csv"
                        maxFileSize="5000000"
                        (onSelect)="onExcelSelect($event)"
                        (onClear)="onExcelClear()"
                        [showUploadButton]="false"
                        [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <div *ngIf="!archivoExcelSubido" class="text-center p-4">
                                <i class="pi pi-cloud-upload text-4xl text-400 mb-2"></i>
                                <p class="text-500">Arrastra un archivo o haz clic para seleccionar</p>
                                <p class="text-400 text-sm">Formatos: .xlsx, .xls, .csv (máx 5MB)</p>
                            </div>
                        </ng-template>
                    </p-fileUpload>
                    
                    <!-- Stats del archivo -->
                    <div class="mt-3" *ngIf="archivoExcelSubido">
                        <div class="flex align-items-center justify-content-between p-3 surface-100 border-round">
                            <div class="flex align-items-center">
                                <i class="pi pi-check-circle text-green-500 text-xl mr-2"></i>
                                <span class="font-bold">{{ excelStats.validos }} destinatarios válidos</span>
                            </div>
                            <div class="text-500 text-sm" *ngIf="excelStats.invalidos > 0">
                                <i class="pi pi-exclamation-triangle text-orange-500 mr-1"></i>
                                {{ excelStats.invalidos }} registros omitidos
                            </div>
                        </div>
                    </div>
                    
                    <!-- Preview -->
                    <div class="mt-3" *ngIf="excelPreview.length > 0">
                        <p class="text-500 text-sm mb-2">Vista previa (primeros 5):</p>
                        <p-table [value]="excelPreview" styleClass="p-datatable-sm" [rows]="5">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Teléfono</th>
                                    <th>Nombre</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr>
                                    <td>{{ row.telefono || row.celular || '-' }}</td>
                                    <td>{{ row.nombre || '-' }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <!-- Título del mensaje -->
                <div class="field">
                    <label class="block text-500 text-sm mb-1">Título del Mensaje *</label>
                    <input pInputText formControlName="nombre" placeholder="ej: Recordatorio de pago" class="w-full"/>
                    <small *ngIf="invalidControl('nombre')" class="text-red-500">El título es requerido</small>
                </div>

                <!-- CONTENIDO DEL MENSAJE -->
                <div class="mb-4 p-2 surface-50 border-round" *ngIf="formGroup.value.tipo === TIPO_SMS">
                    <div class="field">
                        <label class="block text-500 text-sm mb-1">Mensaje SMS</label>
                        <textarea pInputTextarea formControlName="descripcion" rows="6" 
                            placeholder="Escribe el contenido del mensaje..."
                            class="w-full" [autoResize]="true"></textarea>
                        <small class="text-500">{{ formGroup.value.descripcion?.length || 0 }} / 160 caracteres</small>
                        <small *ngIf="invalidControl('descripcion')" class="text-red-500 ml-2">El mensaje es requerido</small>
                    </div>
                </div>

                <!-- WHATSAPP TEMPLATE -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="formGroup.value.tipo !== TIPO_SMS">
                    <div class="flex align-items-center justify-content-between mb-3">
                        <span class="text-900 font-bold">📱 Plantilla de WhatsApp</span>
                        <a [routerLink]="['/pages/notificacion/whatsapp-templates']" class="text-primary no-underline hover:underline">
                            <small><i class="pi pi-external-link mr-1"></i>Gestionar plantillas</small>
                        </a>
                    </div>

                    <div class="mb-3 p-3 border-round" *ngIf="isWhatsappEnvioBloqueado()" style="background: #fff4e5; border: 1px solid #f59e0b;">
                        <small class="text-900">
                            <i class="pi pi-exclamation-triangle mr-1"></i>
                            {{ whatsappConfigEstado.mensaje }}
                            <strong> Ir a Configuración de Empresa para habilitar el canal.</strong>
                        </small>
                    </div>
                    
                    <!-- Cards de plantillas -->
                    <div *ngIf="whatsappTemplates.length > 0" class="grid">
                        <div class="col-12 md:col-6 lg:col-4" *ngFor="let template of whatsappTemplates">
                            <div class="template-card p-3 border-round transition-colors transition-duration-200"
                                [class.border-green-500]="isTemplateSeleccionada(template)"
                                [class.bg-green-50]="isTemplateSeleccionada(template)"
                                [class.border-gray-300]="!isTemplateSeleccionada(template)"
                                [class.bg-white]="!isTemplateSeleccionada(template)"
                                [class.template-card--disabled]="!isTemplateAprobada(template) || isTemplatePendienteDeRecrear(template)"
                                [class.cursor-pointer]="isTemplateAprobada(template) && isTemplateEnMeta(template)"
                                [class.cursor-not-allowed]="!isTemplateAprobada(template) || isTemplatePendienteDeRecrear(template)"
                                [attr.aria-disabled]="!isTemplateAprobada(template) || isTemplatePendienteDeRecrear(template)"
                                (click)="selectWhatsappTemplate(template)">
                                <!-- Header -->
                                <div class="flex align-items-center justify-content-between mb-2">
                                    <span class="font-bold text-lg" [class.text-green-700]="isTemplateSeleccionada(template)">{{ template.nombre }}</span>
                                    <span class="p-tag p-tag-sm" [ngClass]="getTemplateEstadoMeta(template).tagClass">
                                        <i [class]="getTemplateEstadoMeta(template).icon + ' mr-1'"></i>
                                        {{ getTemplateEstadoMeta(template).label }}
                                    </span>
                                </div>
                                <!-- Preview mensaje -->
                                <div class="text-600 text-sm surface-100 p-2 border-round mb-2" style="min-height: 3rem; max-height: 4rem; overflow: hidden;">
                                    {{ template.mensaje }}
                                </div>
                                <!-- Info adicional -->
                                <div class="flex align-items-center justify-content-between text-sm text-500">
                                    <span *ngIf="template.subir_imagen">
                                        <i class="pi pi-image mr-1"></i>Con imagen
                                    </span>
                                    <span *ngIf="!template.subir_imagen">
                                        <i class="pi pi-minus mr-1"></i>Solo texto
                                    </span>
                                    <span *ngIf="isTemplateSeleccionada(template)" class="text-green-600 font-bold">
                                        <i class="pi pi-check-circle mr-1"></i>Seleccionado
                                    </span>
                                    <span *ngIf="isTemplatePendienteDeRecrear(template)" class="text-orange-600 font-semibold">
                                        <i class="pi pi-exclamation-triangle mr-1"></i>Falta recrearla en Meta
                                    </span>
                                    <span *ngIf="!isTemplateAprobada(template)" class="text-700 font-semibold">
                                        <i class="pi pi-lock mr-1"></i>No seleccionable
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Sin plantillas -->
                    <div *ngIf="whatsappTemplates.length === 0" class="text-center p-4">
                        <i class="pi pi-inbox text-4xl text-400 mb-2"></i>
                        <p class="text-500">No hay plantillas disponibles</p>
                        <a [routerLink]="['/pages/notificacion/whatsapp-templates/new']" pButton 
                            label="Crear plantilla" 
                            class="p-button-outlined mt-2">
                        </a>
                    </div>

                    <!-- Mapeo de variables dinámicas -->
                    <div class="mt-3" *ngIf="whatsappTemplateSeleccionada && templateVariableRenderHabilitado && templateVariableControls.length > 0">
                        <div class="mb-2 text-900 font-bold">
                            <i class="pi pi-sitemap mr-1"></i>
                            Mapeo de variables del template
                        </div>

                        <div class="p-3 border-round surface-100">
                            <!--
                                La posición se muestra siempre, incluida la del archivo
                                del encabezado. Esconderla haría creer que el mensaje
                                arranca en la 1 y el operador mapearía todo corrido.
                            -->
                            <div class="grid align-items-center" *ngFor="let item of templateVariableControls; trackBy: trackByTemplateVariable">
                                <div class="col-12 md:col-4">
                                    <span class="font-semibold mr-2">{{ item.variable }}.</span>
                                    <span class="text-700">{{ item.etiqueta }}</span>
                                </div>
                                <div class="col-12 md:col-8">
                                    <p-dropdown
                                        *ngIf="!item.ocupadoPorPlantilla"
                                        [options]="templateFieldsOptions"
                                        optionLabel="label"
                                        optionValue="value"
                                        [formControl]="item.control"
                                        placeholder="Seleccionar campo del sistema"
                                        styleClass="w-full"
                                    ></p-dropdown>

                                    <p-tag
                                        *ngIf="item.ocupadoPorPlantilla"
                                        severity="info"
                                        icon="pi pi-image"
                                        value="Lo completa la plantilla"
                                    ></p-tag>
                                </div>
                            </div>
                            <small class="text-500">
                                Estas variables se completan automáticamente para cada destinatario al enviar.
                            </small>
                            <div class="mt-2" *ngIf="isTemplateMappingIncompleto()">
                                <small class="text-red-500">
                                    Faltan mapear variables obligatorias:
                                    {{ getTemplateVariablesPendientesTexto() }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3 p-3 surface-50 border-round" *ngIf="whatsappTemplateSeleccionada">
                        <div class="flex align-items-center justify-content-between">
                            <div>
                                <span class="font-bold">Respuesta automática</span>
                                <div>
                                    <small class="text-500" *ngIf="templateTieneFlujo">
                                        El bot le sigue la conversación a quien responda, hasta cerrarla o pasarla a una persona.
                                    </small>
                                    <small class="text-500" *ngIf="!templateTieneFlujo">
                                        Esta plantilla no tiene un flujo armado. Las respuestas caen en el inbox como siempre.
                                    </small>
                                </div>
                            </div>
                            <p-inputSwitch
                                [(ngModel)]="flujoHabilitado"
                                [ngModelOptions]="{ standalone: true }"
                                [disabled]="!templateTieneFlujo"
                            ></p-inputSwitch>
                        </div>
                    </div>

                </div>

                <!-- PROGRESS BAR (cuando está enviando) -->
                <div class="mb-4 p-4 surface-50 border-round" *ngIf="mostrarProgreso && jobStatus">
                    <div class="flex align-items-center justify-content-between mb-2">
                        <span class="font-bold">
                            <i class="pi pi-spinner mr-2"></i>
                            Enviando mensajes...
                        </span>
                        <span class="text-500">{{ jobStatus.estado | titlecase }}</span>
                    </div>
                    <p-progressBar [value]="jobStatus.porcentaje" [showValue]="true"></p-progressBar>
                    <div class="flex justify-content-between mt-2 text-sm text-500">
                        <span>{{ jobStatus.procesados }} enviados</span>
                        <span>{{ jobStatus.fallos }} fallidos</span>
                    </div>
                </div>

                <!-- BOTÓN ENVIAR -->
                <div class="flex justify-content-center mt-4">
                    <button pButton pRipple type="button" 
                        label="📱 ENVIAR MENSAJE" 
                        icon="pi pi-send"
                        class="p-button-lg p-button-success"
                        (click)="enviar()"
                        [disabled]="loading || isTemplateMappingIncompleto() || isWhatsappEnvioBloqueado()">
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" 
    [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
    (close)="cerrarOnLista($event)">
</app-on-lista>
